document.addEventListener("DOMContentLoaded", () => {
  const timezoneFields = document.querySelectorAll("[data-timezone]")
  // Create and convert timezone to format +06:00
  const timezone = new Date().toString().match(/([-\+][0-9]+)\s/)[1]; 

  Array.from(timezoneFields).forEach(elem => {
    elem.value = timezone
  })
})
